@if(loading) {
<div class="cc1 scc1">
    <div class="cc2">
        <div class="cc3 skeleton"></div>
    </div>
    <div class="cc4">
        <div class="cc5">
            <div class="cc9">
                <div class="cc6 scc6 skeleton"></div>
                <div class="cc8">
                    <div class="scc8 skeleton"></div>
                </div>
            </div>
            <div class="cc7 scc7 skeleton"></div>
        </div>
        <div class="scc11 cc11">
            <div class="cc12 scc12 skeleton"></div>
            <div class="prcgw sprcgw">
                <span class="abpp sabpp">
                    <div class="ss skeleton"></div>
                </span>
                <span class="prcw sprcw">
                    <div class="ss skeleton"></div>
                </span>
                <span class="pp spp">
                    <div class="ss skeleton"></div>
                </span>
            </div>
        </div>
    </div>
</div>
} @else {
<ng-container *ngTemplateOutlet="regionmode"></ng-container>
}



<ng-template #regionmode>
    <div class="cc1">
        <div class="cc2">
            <img class="cc3" [src]="image?.length > 0 ? image : '../../../../assets/images/empty.jpg'">
            <div class="overlay"></div>
            <div class="abs" multilang [innerHTML]="item?.text?.text | cleverfragment | safehtml">
            </div>
        </div>
    </div>
</ng-template>